import pb from './pocketbase';

export const PUBLIC_SIGNUP_PATH = '/api/public-signup';

const normalizeEmail = (email) => (email || '').toString().trim().toLowerCase();
const normalizeName = (name) => (name || '').toString().trim();

export const buildPublicSignupBody = ({ email, password, name, captchaToken } = {}) => {
  const normalizedEmail = normalizeEmail(email);
  const body = {
    email: normalizedEmail,
    username: normalizedEmail,
    password: password || '',
    passwordConfirm: password || '',
    name: normalizeName(name),
    emailVisibility: true,
  };

  if (captchaToken) {
    body.captchaToken = captchaToken;
  }

  return body;
};

const extractFieldMessage = (data) => {
  const fields = data?.data;
  if (!fields || typeof fields !== 'object') {
    return '';
  }

  const fieldError = Object.values(fields).find((entry) => entry?.message);
  return fieldError?.message || '';
};

export const normalizePublicSignupError = (error) => {
  const response = error?.response || error?.data || {};
  const message = (
    extractFieldMessage(response) ||
    response?.error ||
    response?.message ||
    error?.message ||
    'Signup failed.'
  );
  const normalized = new Error(message);
  normalized.status = error?.status || response?.status || 0;
  normalized.data = response;
  normalized.originalError = error;
  return normalized;
};

export const sendPublicSignup = async (params, client = pb) => {
  const body = buildPublicSignupBody(params);

  try {
    const json = await client.send(PUBLIC_SIGNUP_PATH, {
      method: 'POST',
      body,
      $autoCancel: false,
    });

    if (!json || json.success === false) {
      throw normalizePublicSignupError({ response: json || {} });
    }

    return {
      id: json.userId || json.id || null,
      email: json.email || body.email,
      created: Boolean(json.created),
    };
  } catch (error) {
    throw normalizePublicSignupError(error);
  }
};
